import calls from '@/backend/api-calls'

const state = () => ({
  warehouses: [],
  loading: false
})

// getters
const getters = {
}

// actions
const actions = {
  getWarehouses: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.warehouses.get(parameters)
        .then(resp => {
          commit("setWarehouses", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addWarehouse({commit}, { data, parameters }) {
    return new Promise((resolve, reject) => {
      calls.warehouses.post(data, parameters)
        .then(resp => {
          commit("insertWarehouse", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Warehouse successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateWarehouse: ({commit}, { warehouseId, data }) => {
    return new Promise((resolve, reject) => {
      calls.warehouse.put(warehouseId, data).then(
        resp => {
          commit("insertUpdatedWarehouse", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Warehouse successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteWarehouse: ({commit}, warehouseId) => {
    return new Promise((resolve, reject) => {
      calls.warehouse.delete(warehouseId).then(
        resp => {
          commit("removeWarehouse", warehouseId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Warehouse successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setWarehouses(state, data) {
    state.pagination = data.pagination;
    state.warehouses = data.results;
  },
  insertWarehouse(state, data) {
    state.warehouses.push(data);
  },
  insertUpdatedWarehouse(state, data) {
    state.warehouses.forEach((warehouse, i) => {
      if (warehouse.id == data.id) {
        state.warehouses.splice(i, 1, data);
      }
    })
  },
  removeWarehouse(state, warehouseId) {
    state.warehouses.forEach((warehouse, i) => {
      if (warehouse.id == warehouseId) {
        state.warehouses.splice(i, 1);
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}